import { theme } from "@academy/utils";
import { NavGroup } from "@academy/components";

const navLinks: Record<string, NavGroup[]> = {
    default: [
        {
            title: "footer.nav.about-us-title",
            links: [
                {
                    title: "footer.nav.about-us.careers",
                    routeName: "/home",
                    isOuterLink: false,
                },
                {
                    title: "footer.nav.about-us.who-we-are",
                    routeName: "https://smartsafeschool.com",
                    isOuterLink: true,
                },
            ],
        },
        {
            title: "footer.nav.for-business-title",
            links: [
                {
                    title: "footer.nav.for-business.become-a-vendor",
                    routeName: "/for-business",
                    isOuterLink: false,
                },
                {
                    title: "footer.nav.for-business.log-in",
                    routeName: "/login",
                    isOuterLink: false,
                },
            ],
        },
        {
            title: "footer.nav.for-investors-title",
            links: [
                {
                    title: "footer.nav.for-investors.become-an-investor",
                    routeName: "/for-investors",
                    isOuterLink: false,
                },
            ],
        },
        {
            title: "footer.nav.help-title",
            links: [
                {
                    title: "footer.nav.help.support",
                    routeName: "/home",
                    isOuterLink: false,
                },
                {
                    title: "footer.nav.help.payment",
                    routeName: "/login",
                    isOuterLink: false,
                },
                {
                    title: "footer.nav.help.faq",
                    routeName: "/login",
                    isOuterLink: false,
                },
            ],
        },
    ],
    kids: [
        {
            links: [
                // {
                //   title: "common.categories",
                //   routeName: "#categories",
                //   isOuterLink: false,
                //   isAnchorLink: true,
                // },
                {
                    title: "common.workshops",
                    routeName: "/programs",
                    isOuterLink: false,
                    hideOnMobile: true,
                },
                {
                    title: "Partnership",
                    routeName: "/partnership",
                    isOuterLink: false,
                    hideOnMobile: true,
                },
                {
                    title: "common.investment-deck",
                    routeName: "/investment-deck",
                    isOuterLink: false,
                    hideOnMobile: true,
                },
            ],
        },
        {
            links: [
                // {
                //     title: "how-it-works-page.title",
                //     routeName: "/how-it-works",
                //     isOuterLink: false,
                // },
                {
                    title: "common.franchising",
                    routeName: "/franchising",
                    isOuterLink: false,
                },
                {
                    title: "footer.nav.about-us-title",
                    routeName: "/about",
                    isOuterLink: false,
                },
                {
                    title: "footer.nav.contact-us",
                    routeName: "/contacts",
                    isOuterLink: false,
                },
            ],
        },
        {
            links: [
                /*        {
          title: "footer.nav.shipping-returns",
          routeName:
            "https://kidscrafts.shop/shipping-returns-policy/store-en.html",
          isOuterLink: true,
        },*/

                {
                    title: "footer.nav.policy",
                    routeName: "/privacy-policy",
                    isOuterLink: true,
                },
                {
                    title: "footer.nav.terms-of-use",
                    routeName: "/agreement",
                    isOuterLink: true,
                },
                // {
                //     title: "common.investment-deck",
                //     routeName: "/investment-deck",
                //     isOuterLink: false,
                // },
            ],
        },

        /*    {
      links: [
        {
          title: "footer.nav.terms-of-use",
          routeName: "https://kidscrafts.shop/agreement/store-en.html",
          isOuterLink: true,
        },
        {
          title: "footer.nav.terms-of-use-partners",
          routeName: "https://kidscrafts.shop/agreement/partners-en.html",
          isOuterLink: true,
        },
      ],
    },*/
    ],
};

export default navLinks[theme] || navLinks.default;
